import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

export class Popup {
    public description: string;
    public disabled: boolean;
    public buttonText: string;
    public buttonIsHidden?: boolean;
    public hideIcon?: boolean;
}

@Component({
    selector: 'cb-popup-tip',
    templateUrl: './popup-tip.component.html',
    styleUrls: ['./popup-tip.component.scss'],
    standalone: false
})
export class PopupTipComponent implements OnDestroy {
    @Input() public popup?: Popup;

    @Output() public readonly popupClick = new EventEmitter();

    @ViewChild('helpTrigger') private helpTrigger!: MatMenuTrigger;

    private closeTimer?: ReturnType<typeof setTimeout>;
    private readonly HELP_CLOSE_DELAY = 200;

    public onHelpEnter(): void {
        if (this.closeTimer) {
            clearTimeout(this.closeTimer);
            this.closeTimer = undefined;
        }
        if (this.helpTrigger && !this.helpTrigger.menuOpen) {
            this.helpTrigger.openMenu();
        }
    }

    public onHelpLeave(): void {
        if (this.closeTimer) {
            clearTimeout(this.closeTimer);
        }
        this.closeTimer = setTimeout(() => {
            if (this.helpTrigger?.menuOpen) {
                this.helpTrigger.closeMenu();
            }
            this.closeTimer = undefined;
        }, this.HELP_CLOSE_DELAY);
    }

    public ngOnDestroy(): void {
        if (this.closeTimer) {
            clearTimeout(this.closeTimer);
        }
    }

    public readonly onPopupClick = (event: MouseEvent): void => {
        this.popupClick?.emit(event);
    };
}
